import {inject, Injectable} from '@angular/core';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {
  private readonly userService: UserService = inject(UserService);

  outletConfigurationVisible: boolean;

  constructor() {
    const userService: UserService = this.userService;
    userService.user$.subscribe((): boolean => this.outletConfigurationVisible = this.userService.userIsDealerAdmin());
  }
}
